import { CloseSmallIcon } from '@/components/icons'
import { Box, Stack, Typography } from '@mui/material'
import classes from './styles.module.scss'
import _ from 'lodash'
import { useAppDispatch, useAppSelector } from '@store/stores'
import {
  EFilterType,
  stationGeoTagDeviceSliceActions,
  stationGeoTagDeviceState,
} from '@store/slices/StataionGeoTagDevice/stationGeoTagDeviceSlice'

const filterAllowed = [
  EFilterType.PlantIds,
  EFilterType.EmitterIds,
  EFilterType.SoilIds,
  // EFilterType.SubAreaIds,
]
const ListFilterStationsV2 = () => {

  const dispatch = useAppDispatch()
  const stationGeoTagDevice = useAppSelector(stationGeoTagDeviceState)

  const currentFilter = (key: EFilterType.PlantIds | EFilterType.EmitterIds | EFilterType.SoilIds) => {
    try {
      const t = key in stationGeoTagDevice.filter ? stationGeoTagDevice.filter[key] : []
      return t
    } catch (e) {
      console.error(e)
      return []
    }
  }

  const handleDelete = (id: number | undefined, key: string) => {
    dispatch(stationGeoTagDeviceSliceActions.removeSingleById({
        type: key,
        value: id,
      },
    ))
  }

  return (
    <Stack
      direction={'row'}
      // flexWrap={'wrap'}
      gap={1}
      alignItems={'center'}
      sx={{
        mt: 1,
      }}
    >
      {
        // not show subAreaIds filter
        _.entries(stationGeoTagDevice.rawFilter).map(([key, value]: any[]) => (
          _.includes(filterAllowed, key)
          && _.intersection(currentFilter(key), _.map(value, 'id')).length > 0
          && value.map((item: any, index: number) => (
            <Stack
              key={`${key}-${index}`}
              direction="row"
              spacing={2}
              flexWrap={'nowrap'}
              alignItems={'center'}
              justifyContent={'flex-start'}
              sx={{
                whiteSpace: 'nowrap',
                width: 'auto',
                flexGrow: 1,
                border: '1px solid #d7d7d7',
                borderRadius: '4px',
                padding: '3px 6px',
              }}
            >
              <Typography className={classes.txtDescription}>
                {item?.emitter || item?.description}
              </Typography>

              <Box
                className={classes.btnDelete}
                onClick={() => handleDelete(item.id, key)}
              >
                <CloseSmallIcon sx={{ mt: '4px', color: 'text.main' }} />
              </Box>
            </Stack>
          ))
        ))
      }

    </Stack>
  )
}

export default ListFilterStationsV2
